import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import MapImg from '../../images/map1.png'
import './index.css';
import Storage from '../../services/Storage';
import DateService from '../../services/DateService';
import { Roles } from '../../constants/Roles';

const BasicBusinessInformation = ({
  previewData,
  selectedState,
  selectedDistrict,
  selectedCity,
  userId,
}) => {
  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const navigate = useNavigate();
  const location = useLocation();

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };

  return (
    <div id='basicInfo'>
      <Row>
        <Col lg={9} md={6}>
          <div className='main-title'>
            Business Information
            {roleName &&
              (roleName === Roles.TM_NAME ||
                roleName === Roles.BH_NAME ||
                (roleName === Roles.SH_NAME &&
                  previewData.created_by &&
                  previewData.created_by === roleId)) ? (
              <i
                onClick={() => {
                  setBreadcrumbsRecord();
                  navigate({
                    pathname: `/pages/basic-business-info/${Storage.getAddNewDealerId() ? Storage.getAddNewDealerId() : userId}`,
                    // pathname: `/pages/basic-business-info/${userId}`,
                  });
                }}
                className='fa fa-edit editButton noprint'
              ></i>
            ) : (
              ''
            )}
          </div>
        </Col>
        {previewData.application_creation_date && (
          <Col lg={3} md={6}>
            <div className='application-date'>
              <span className='common-title'>Application Date</span>
              <div className='application-date-time'>
                <i
                  style={{ color: '#545CD8' }}
                  className='fa fa-calendar mr-1 noprint'
                ></i>
                <span className='mr-2'>
                  {DateService.localDateOnly(previewData.application_creation_date) || 'N/A'}
                </span>
              </div>
            </div>
          </Col>
        )}
        <Col xs={12}>
          <div className='application-id'>
            <div className='common-heading'>Form Number</div>
            {/* <div>{previewData.user_id}</div> */}
            <div className='subData'>{previewData.id}</div>
          </div>
        </Col>
        <Col xs={12}>
          <div className='infodatablock'>
            {previewData.application_for && (
              <div className='info'>
                <div className='common-heading'>Application For</div>
                <div className='subData'>{previewData.application_for}</div>
              </div>
            )}
            <div className='info'>
              <div className='common-heading'>Territory</div>
              <div className='subData'>{previewData.territory_name}</div>
            </div>
            {previewData.business_type && (
              <div className='info'>
                <div className='common-heading'>Business Type</div>
                <div className='subData'>{previewData.business_type}</div>
              </div>
            )}
            {previewData.business_name && (
              <div className='info'>
                <div className='common-heading'>Dealership Name</div>
                <div className='subData'>{previewData.business_name}</div>
              </div>
            )}
            {previewData.business_incorporation_date && (
              <div className='info'>
                <div className='common-heading'>
                  Business Incorporation Date
                </div>
                <div className='subData'>
                  <i
                    style={{ color: '#545CD8' }}
                    className='fa fa-calendar noprint'
                  ></i>{' '}
                  {DateService.utcToLocalDateOnly(previewData.business_incorporation_date) || 'N/A'}
                </div>
              </div>
            )}
            {previewData.no_of_retial_outlets &&
              previewData.application_for === 'Distributor' && (
                <div className='info'>
                  <div className='common-heading'>
                    Number of dealers working with
                  </div>
                  <div className='subData'>
                    {previewData.no_of_retial_outlets}
                  </div>
                </div>
              )}
            {previewData.no_of_farmers &&
              previewData.application_for === 'Dealer' && (
                <div className='info'>
                  <div className='common-heading'>
                    Number of farmers working with
                  </div>
                  <div className='subData'>{previewData.no_of_farmers}</div>
                </div>
              )}
            {previewData.no_of_employees && (
              <div className='info'>
                <div className='common-heading'>No. of Employees</div>
                <div className='subData'>{previewData.no_of_employees}</div>
              </div>
            )}
            {previewData.address && (
              <div className='info'>
                <div className='common-heading'>Address</div>
                <div className='subData'>{previewData.address}</div>
              </div>
            )}

            {previewData.pincode && (
              <div className='info'>
                <div className='common-heading'>Pincode</div>
                <div className='subData'>{previewData.pincode}</div>
              </div>
            )}

            {selectedState.length > 0 &&
              selectedState.map((val, index) => {
                return (
                  <div className='info' key={index}>
                    <div className='common-heading'>State</div>
                    <div className='subData'>{val.state_name}</div>
                  </div>
                );
              })}

            {selectedDistrict.length > 0 &&
              selectedDistrict.map((val, index) => {
                return (
                  <div className='info' key={index}>
                    <div className='common-heading'>District</div>
                    <div className='subData'>{val.district_name}</div>
                  </div>
                );
              })}

            {selectedCity.length > 0 &&
              selectedCity.map((val, index) => {
                return (
                  <div className='info' key={index}>
                    <div className='common-heading'>City/Town</div>
                    <div className='subData'>{val.city_or_town_name}</div>
                  </div>
                );
              })}

            {/* https://maps.google.com/?q=23.08825,72.68235 */}
            <div className='info'>
              <div className='common-heading'>Dealer Location</div>
              {previewData && previewData.latitude && previewData.longitude ?
                <div className='subData'>
                  <img src={MapImg} alt='mapIcon' className='mapIcon' onClick={() => window.open(`https://maps.google.com/?q=${previewData.latitude},${previewData.longitude}`, '_blank')} />
                </div>
                :
                <div className='subData'>Location is not set</div>
              }
            </div>

            {previewData.landline_number && previewData.std_code && (
              <div className='info'>
                <div className='common-heading'>Landline Number</div>
                <div className='subData'>{`${previewData.std_code} - ${previewData.landline_number}`}</div>
              </div>
            )}
            {previewData.landline_number && previewData.std_code == null && (
              <div className='info'>
                <div className='common-heading'>Landline Number</div>
                <div className='subData'>{`${previewData.landline_number}`}</div>
              </div>
            )}
            {previewData.website && (
              <div className='info'>
                <div className='common-heading'>Website</div>
                <div className='subData'>{previewData.website}</div>
              </div>
            )}
            {previewData.facebook_page && (
              <div className='info'>
                <div className='common-heading'>FB Page Link</div>
                <div className='subData'>{previewData.facebook_page}</div>
              </div>
            )}
            {previewData && previewData.th && (
              <div className='info'>
                <div className='common-heading'>SE/TM Name</div>
                <div className='subData'>{previewData.th}</div>
              </div>
            )}
          </div>
        </Col>
        {previewData.frontage &&
          previewData.depth &&
          previewData.ceiling_height ? (
          <>
            <Col xs={12}>
              <div className='common-title shopBlock'>Shop Information</div>
            </Col>
            <Col xs={12}>
              <div className='infodatablock'>
                {previewData.frontage && (
                  <div className='info'>
                    <div className='common-heading'>Frontage (ft)</div>
                    <div className='subData'>
                      {previewData.frontage.toFixed(2)}
                    </div>
                  </div>
                )}
                {previewData.depth && (
                  <div className='info'>
                    <div className='common-heading'>Depth (ft)</div>
                    <div className='subData'>
                      {previewData.depth.toFixed(2)}
                    </div>
                  </div>
                )}
                {previewData.ceiling_height && (
                  <div className='info'>
                    <div className='common-heading'>Ceiling height (ft)</div>
                    <div className='subData'>
                      {previewData.ceiling_height.toFixed(2)}
                    </div>
                  </div>
                )}
                {previewData.frontage && previewData.depth && (
                  <div className='info'>
                    <div className='common-heading'>
                      Total area of shop (in Sqft)
                    </div>
                    <div className='subData'>
                      {previewData.frontage * previewData.depth
                        ? (previewData.frontage * previewData.depth).toFixed(2)
                        : null}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </>
        ) : (
          ''
        )}
        {previewData.total_area_of_storage ? (
          <>
            <Col xs={12}>
              <div className='common-title shopBlock'>Storage Information</div>
            </Col>
            <Col xs={12}>
              <div className='infodatablock'>
                <div className='info mb-0'>
                  <div className='common-heading'>
                    Total Area of Storage (in Sqft)
                  </div>
                  <div className='subData'>
                    {previewData.total_area_of_storage &&
                      previewData.total_area_of_storage.toFixed(2)}
                  </div>
                </div>
              </div>
            </Col>
          </>
        ) : (
          ''
        )}
      </Row>
    </div>
  );
};

export default React.memo(BasicBusinessInformation);
